import React, {useEffect} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import FormGroup from '@mui/material/FormGroup';

import {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {ROUTES} from "../../../../../routes";
import {changeUserInfo} from "../../../../../actions/actionFunctions";
import GroheCartHeaderCommon from "../groheCartHeaderCommon";
import GroheCartStickyFooter from "../groheCartStickyFooter";
import {setUserTwoFa} from "../../../../../actions/userFunctions";
import TwoFaCodeInput, {sendAuthRequest} from "../../../ui/twoFaCodeInput";


const GroheCartTwoFAVerify = (props) => {

  const {history, userInfo, userIsLoggedIn, isMobile, twoFALoading, setUserTwoFa} = props;

  useEffect(() => {
    resendCodeButtonClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resendCodeButtonClick = async () => {
    await sendAuthRequest(twoFALoading, PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartTwoFAResendCode, userInfo, userIsLoggedIn, 1, setUserTwoFa);
  };

  const receiveCallButtonClick = async () => {
    await sendAuthRequest(twoFALoading, PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartTwoFAReceiveCall, userInfo, userIsLoggedIn, 2, setUserTwoFa);
  };

  const stickyFooterButtons = [
    {
      translate: "buttons.back",
      classes: "look-button--secondary",
      onClick: () => {
        history.push(ROUTES.cartTwoFA);
      }
    },
    {
      translate: "grohe.cart.twoFA.verify.resendCodeButton",
      classes: "look-button--secondary gc-sticky__button--40",
      onClick: resendCodeButtonClick
    },
    {
      translate: "grohe.cart.twoFA.verify.receiveCallButton",
      classes: "look-button--secondary gc-sticky__button--40",
      onClick: receiveCallButtonClick
    }
  ];

  return (
    <div className="gc">
      <div className="gc-body">
        <GroheCartHeaderCommon title="grohe.cart.twoFA.title" subTitle="grohe.cart.twoFA.subTitle"/>
        <FormGroup className="gc-form">
          <TwoFaCodeInput/>
          {isMobile ? null : (
            <div className="gc-form__submit">
              <div className="gc-form__submit-left"/>
              <div className="gc-form__submit-right">
                <Button className="look-button look-button--secondary look-button--big look-button--large nowrap"
                  // disabled={loaderOpened}
                        onClick={receiveCallButtonClick}>
                  <FormattedMessage id="grohe.cart.twoFA.verify.receiveCallButton"/>
                </Button>
                <Button className="look-button look-button--secondary look-button--big look-button--large nowrap"
                  // disabled={loaderOpened}
                        onClick={resendCodeButtonClick}>
                  <FormattedMessage id="grohe.cart.twoFA.verify.resendCodeButton"/>
                </Button>
              </div>
            </div>
          )}
        </FormGroup>
        {isMobile ? <div className="gc-spacer"/> : null}
      </div>
      {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {userInfo, userIsLoggedIn, userTwoFa} = store.userState;
  const {isMobile} = store.serverState;
  const {twoFALoading} = userTwoFa;

  return {
    userInfo,
    userIsLoggedIn,
    twoFALoading,
    isMobile,
  };
};

const mapDispatchToProps = {
  changeUserInfo,
  setUserTwoFa,
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(GroheCartTwoFAVerify)
  )
)
